import React from 'react'
import { Link } from 'react-router'
import { List } from '@chakra-ui/react'
import { Text } from '.'

export default (props) => {
  return (
    <List.Root gap={props.spacing} ml={5}>
      {props.items.map((item, index) => (
        <List.Item key={item.key ?? index}>
          <Text as={item.to ? Link : null} to={item.to} color={item.to ? 'primary.500' : null}>{item.content}</Text>
        </List.Item>))}
    </List.Root>
  )
}
